export default __webpack_public_path__ + "locales/ja-JP/DeleteSelfProfileDialog.json?hash=4e708439ddcb70ae548d8cc63e5a8a4f";